// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "115f09fab22252cd277cd70856124a6b4714b65f/scripts/" + chunkId + ".js";
};